/**
 * Utility functions for object manipulation
 */

/**
 * Safely gets a nested property value from an object using dot notation
 * @param obj - The object to access
 * @param path - The dot-notation path (e.g., "customer.firstName")
 * @returns The value at the path, or undefined if the path doesn't exist
 */
export function getNestedValue<T = any>(obj: any, path: string): T | undefined {
  if (!obj || !path) {
    return undefined;
  }

  return path.split(".").reduce((current, key) => {
    return current && typeof current === "object" ? current[key] : undefined;
  }, obj);
}
